"use strict";

angular.module("portal.lookup")
    .controller('PortalLookup', ['ngReactBridge', '$scope',
        /**
         * @param {any} ngReactBridge
         * @param {Record<string, any>} $scope
         */
        function (ngReactBridge, $scope) {
            var resource = "imagetrend-lms-portal";
            var basename = "/";

            $scope.reactReady = false;
            ngReactBridge.initializeAsync(resource, basename).then(function () {
                $scope.reactReady = true;
                $scope.$apply();
            }).catch(function (err) {
                console.error("Failed to initialize", err);
                $scope.reactError = true;
                $scope.$apply();
            });
        }])
    .directive("lookupModule", ["ngReactBridge", function (ngReactBridge) {
        var basename = "/";
        var portal = true;
        var renderFunc = imagetrend.lms.portal.renderPortalApp;
        var cleanupFunc = imagetrend.lms.portal.cleanupPortalApp;
        return ngReactBridge.createNgReactDirective(basename, portal, renderFunc, cleanupFunc);
    }]);
